import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadFileComponent } from './platform/modules/download-file/download-file.component';
import { PrivacyPolicyComponent } from './platform/modules/login/privacy-policy.component';
import { AuthenticationGuard } from './auth/guards/authentication.guard';
const routes: Routes = [
  {
    path: 'auth',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./auth/auth.module').then( m => m.AuthModule )
  },{
    path: '',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./modules/main.module').then( m => m.MainModule )
  },
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   redirectTo: '/web/login'
  // },
  // {
  //   path: 'privacy',
  //   component: PrivacyPolicyComponent
  // },
  // {
  //   path: 'web',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () => import('./platform/platform.module').then(x => x.PlatformModule)
  // },
  // {
  //   path: 'webadmin',
  //   canActivate: [AuthenticationGuard],
  //   loadChildren: () => import('./super-admin-portal/super-admin-portal.module').then(x => x.SuperAdminPortalModule)
  // },
  // {
  //   path: '.well-known/apple-app-site-association',
  //   component: DownloadFileComponent
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
